import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}" }) }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.924 3.05)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "a",
				d: "M9.179,5.229h0a3.949,3.949,0,0,1,3.95,3.95h0a3.949,3.949,0,0,1-3.95,3.95h0a3.949,3.949,0,0,1-3.95-3.95h0A3.949,3.949,0,0,1,9.179,5.229Z",
				transform: "translate(-3.102 -5.229)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "a",
				d: "M12,10.809V8.615",
				transform: "translate(-5.924 -6.64)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "a",
				d: "M11.937,15.047a.088.088,0,1,0,.088.087.088.088,0,0,0-.088-.087",
				transform: "translate(-5.861 -9.32)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "a",
				d: "M20.326,5.757a6.063,6.063,0,0,1,0,7.283",
				transform: "translate(-9.393 -5.449)"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "a",
				d: "M2.8,13.041a6.063,6.063,0,0,1,0-7.283",
				transform: "translate(-1.584 -5.449)"
			})
		]
	})]
});
export default SvgWarning;
